import type { ReactNode } from "react";
import { useIsClient } from "@/hooks/useIsClient";

export const ClientOnly = ({ children }: { children: ReactNode }) => {
  const isClient = useIsClient();
  return isClient ? children : null;
};
